<template>
  <el-dialog title="生产套码"
    :visible.sync="visible"
    width="500px"
    @close='handleClose'
    :close-on-press-escape="false">
    <el-form :model="produceInfo"
      v-loading="loading"
      :rules="rules"
      ref="ruleForm"
      label-width="120px">
      <el-form-item label="标签类型:"
        prop="tagType">
        <el-select v-model="produceInfo.tagType"
          placeholder="请选择标签类型:">
          <el-option v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分配企业:"
        prop="refVendorId">
        <assign-ent-select v-model="produceInfo.refVendorId"
          :option="{tagType: produceInfo.tagType, tagModel: 2 }" />
      </el-form-item>
      <el-form-item label="生产套数:"
        prop="setCount">
        <el-input-number v-model="produceInfo.setCount"
          controls-position="right"
          :min="1"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item label="包装规格:"
        prop="corratio">
        <el-input-number v-model="produceInfo.corratio"
          controls-position="right"
          :min="2"
          :precision="0">
        </el-input-number>个/套
      </el-form-item>
      <el-form-item label="套码起止序号:">
        <span v-if="tagRange.beginTagNo">{{tagRange.beginSetNo | tagCount() }} - {{tagRange.endSetNo | tagCount() }}</span>
      </el-form-item>
      <el-form-item label="标签起止序号:">
        <span v-if="tagRange.beginTagNo">{{tagRange.beginTagNo | tagCount() }} - {{tagRange.endTagNo | tagCount() }}</span>
      </el-form-item>
    </el-form>
    <span slot="footer"
      class="dialog-footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">取 消</el-button>
      <el-button type="primary"
        @click="addsetsegment"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import AssignEntSelect from '@/components/business/assign-ent-select.vue'
let t
export default {
  name: 'produce-modal',
  components: { AssignEntSelect },
  props: {
    fetch: {
      type: Function,
      required: true
    },
    fetchAll: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      options: [
        {
          value: 2,
          label: '涂层标签'
        },
        {
          value: 3,
          label: '芯片标签'
        },
        {
          value: 4,
          label: '普通标签'
        }
      ],
      visible: false,
      produceInfo: {
        tagType: null,
        refVendorId: null,
        setCount: 1,
        corratio: 2
      },
      tagRange: {},
      rules: {
        tagType: [{ required: true, message: '请选择标签类型', trigger: 'blur' }],
        refVendorId: [{ required: false, message: '请选择分配企业', trigger: 'change' }],
        setCount: [{ required: true, message: '请输入生产套数', trigger: 'blur' }],
        corratio: [{ required: true, message: '请输入包装规格', trigger: 'blur' }]
      }
    }
  },
  watch: {
    produceInfo: {
      handler (val, oldVal) {
        if (val.tagType && val.setCount && val.corratio) {
          clearTimeout(t)
          t = setTimeout(() => {
            this.getnextsetsegmentinfo()
          }, 500)
        }
      },
      deep: true
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.tagRange = {}
    },
    addsetsegment () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          let isPreassign = this.produceInfo.refVendorId ? 1 : 0
          this.$store.dispatch('label/addsetsegment', {
            payload: {
              ...this.produceInfo,
              isPreassign
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
              if (isPreassign === 1) {
                this.fetchAll()
              } else {
                this.fetch()
              }
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    getnextsetsegmentinfo () {
      if (!this.produceInfo.tagType || !this.produceInfo.setCount || !this.produceInfo.corratio) {
        return
      }
      this.loading = true
      this.$store.dispatch('label/getnextsetsegmentinfo', {
        payload: {
          tagType: this.produceInfo.tagType,
          vendorId: this.produceInfo.refVendorId,
          setCount: this.produceInfo.setCount,
          corratio: this.produceInfo.corratio
        },
        success: (res) => {
          this.loading = false
          this.tagRange = res.data
        },
        fail: () => {
          this.loading = false
          this.tagRange = {}
        }
      })
    }
  }
}
</script>
